var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-slider',{attrs:{"ticks":"always","tick-size":"4","tick-labels":[0, 200, 400, 600, 800, 1000, 1200, 1400, 1600, 1800, 2000],"hint":"delay","step":"200","min":"0","max":"2000","hide-details":"","value":_vm.value()},on:{"change":_vm.onChangeDelay}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }